type NonEmptySingleCharString<T extends string> = T extends `${string}${infer Rest}`
    ? Rest extends ''
        ? T
        : never
    : never;

/**
 * Strips the specified leading character from a string, if present, and returns original string if not
 *
 * @param input - string to be checked and updated
 * @param leadingCharacter - the string character to check for
 * @returns - updated or original string
 */
export function stripLeadingCharacter<T extends string>(
    input: string,
    leadingCharacter: NonEmptySingleCharString<T>,
): string {
    return input.startsWith(leadingCharacter) ? input.substring(1) : input;
}
